<h2 class="competency-header">Reflect on your professional development goals</h2>
<p>The Tool sets out the competencies included in the Professional Development Profile. You can choose to self-assess your proficiency for as many competencies as you like before identifying your learning goals and activities for this year’s CPD plan. You must choose at least two competencies from the Profile to add to your annual plan, but you may add others, including competencies that aren’t included in the Profile.</p>
<p>Before you begin your self-assessment, it might be helpful to reflect on the questions below to help you identify your current learning goals and priorities.</p>
<div class="question-box">
    Based on your current practice profile, do you have some learning needs in mind?
</div>
<div class="question-box">
    If not, what are your career goals? For example, do you want to:
    <ul>
        <li>
            Increase your knowledge or skills in a specific area?
        </li>
        <li>
            Make partner at your firm?
        </li>
        <li>
            Advance into management at your organization?
        </li>
        <li>
            Move into a C-suite role?
        </li>
        <li>
            Move into a new practice area or setting?
        </li>
        <li>
            Start the process of winding down or retirement?
        </li>
        <li>
            Open your own practice?
        </li>
    </ul>
</div>
<div class="question-box">
    Are there any competencies you know you need to improve on? For example, have you received any feedback or had an experience that indicates a need for more development in a particular area?
</div>
<div class="question-box">
    Are there any areas of the Profile you haven’t explored yet?
</div>
<p class="last-paragraph">The Practice Setting / Career Stage Suggestions tile on the home page provides some suggestions for competencies and learning activities to focus on for various practice settings and career stages. There are many ways to scale your CPD plan to your current circumstances and learning preferences.</p>